import React from 'react'
import { ElectricCategoryCard } from './ElectricCategoryCard'
import { electronicsData } from './interface/Electric'
import {useAppSelector } from '../../../../State/Store'


export const ElectricCatgory = () => {
  const data = useAppSelector(store=>store.homeCategory.homePageData)
  


  return (
    <div className="flex flex-wrap justify-between py-5 lg:px-20 border-b">
        {data?.electricCategories.map((item)=><ElectricCategoryCard item={item}/>)}
    </div>
  )
}
